import API from './../../api'

export default {
  namespaced: true,
  state: {
    priceHistory: [],
    addPriceForm: {
      price: ""
    }
  },
  mutations: {
    setPriceHistory (state, priceHistory) {
      state.priceHistory = priceHistory
    },
  },
  actions: {
    getPropertyPriceHistory: async ({ commit }, unifiedAddressID) => {
      try {
        const priceHistory = await API.getPropertyPriceHistory(unifiedAddressID);
        commit("setPriceHistory", priceHistory);
      } catch (e) {
        console.log(e);
      }
    },
    addPrice: async ({commit, state}, unifiedAddressID) => {
      try {
        commit('setLoading', true, { root: true })
        let today = new Date();
        let ts = Math.floor(today/1000);
        if (state.addPriceForm.price > 0) {
          await API.recordPrice(unifiedAddressID, state.addPriceForm.price, ts);
          const priceHistory = await API.getPropertyPriceHistory(unifiedAddressID);
          commit("setPriceHistory", priceHistory);
          commit('setLoading', false, { root: true });
        }
      } catch (e) {
        console.log(e);
        commit('setLoading', false, { root: true });
      }
    }
  },
  getters: {
    priceHistory: state => state.priceHistory,
    addPriceForm: state => state.addPriceForm,
  }
}
